import { render } from "./MentionChip.vue?vue&type=template&id=91102faa&scoped=true"
import script from "./MentionChip.vue?vue&type=script&lang=js"
export * from "./MentionChip.vue?vue&type=script&lang=js"

import "./MentionChip.vue?vue&type=style&index=0&id=91102faa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91102faa"]])

export default __exports__